import {useMemo} from "react";
import {Box, Grid, Typography} from "@mui/material";
import MySelect from "../../../../components/MySelect";
import MyTextField from "../../../../components/MyTextField";
import {useCountries} from "../../../../hooks/useCountries";

// Step 2 — Profile & Classification. Business Unit and User Type are emphasized (they determine the
// groups and fields in later steps); Country is always shown regardless of user type. Changing BU or
// User Type clears any group selection (handled by the wizard shell's setField).
const Step2Profile = (ctx) => {
    const {draft, setField, businessUnits, userTypes} = ctx;

    const countries = useCountries(draft.businessUnitCode, !!draft.businessUnitCode);

    const userTypeOptions = useMemo(
        () => (userTypes ?? []).map((ut) => ({id: ut.id, name: ut.displayName})),
        [userTypes]
    );

    const sectionLabel = {fontWeight: 700, fontSize: "0.8rem", textTransform: "uppercase", letterSpacing: "0.06em", color: "text.secondary", mb: 0.5};

    return (
        <Box sx={{maxWidth: 720, mx: "auto"}}>
            {/* Classification — emphasized, chosen first */}
            <Box sx={{p: 2, borderRadius: "8px", border: 2, borderColor: "secondary.main", backgroundColor: "rgba(0, 163, 255, 0.04)"}}>
                <Typography sx={sectionLabel}>Classification</Typography>
                <Typography sx={{fontSize: "0.8rem", color: "text.secondary", mb: 1}}>
                    Business Unit and User Type determine the available groups and the fields shown in later steps.
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <MySelect
                            label="Business Unit"
                            options={businessUnits}
                            value={draft.businessUnitCode}
                            required={true}
                            onChange={(value) => setField("businessUnitCode", value)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <MySelect
                            label="User Type"
                            options={userTypeOptions}
                            value={draft.userTypeId}
                            required={true}
                            onChange={(value) => setField("userTypeId", value)}
                        />
                    </Grid>
                </Grid>
            </Box>

            {/* Basic Info */}
            <Box sx={{mt: 3}}>
                <Typography sx={sectionLabel}>Basic Info</Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <MyTextField
                            value={draft.firstName}
                            editable={true}
                            label="First Name"
                            type="text"
                            required={true}
                            onChange={(e) => setField("firstName", e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <MyTextField
                            value={draft.lastName}
                            editable={true}
                            label="Last Name"
                            type="text"
                            required={true}
                            onChange={(e) => setField("lastName", e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <MySelect
                            label="Country"
                            options={countries}
                            value={draft.countryCode}
                            required={true}
                            autoSelect={draft.countryCode || true}
                            onChange={(value) => setField("countryCode", value)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <MyTextField
                            value={draft.phoneNumber}
                            editable={true}
                            label="Phone Number"
                            type="text"
                            required={false}
                            onChange={(e) => setField("phoneNumber", e.target.value)}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default Step2Profile;
